import { render, staticRenderFns } from "./f-checkbox.vue?vue&type=template&id=06458867&scoped=true&"
import script from "./f-checkbox.vue?vue&type=script&lang=js&"
export * from "./f-checkbox.vue?vue&type=script&lang=js&"
import style0 from "./f-checkbox.vue?vue&type=style&index=0&id=06458867&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06458867",
  null
  
)

export default component.exports